import React from 'react';
import { observer } from 'mobx-react-lite';
import { Search } from 'semantic-ui-react';
import debounce from 'lodash.debounce';

import getCampaigns from '../services/getCampaigns';

const resultRenderer = ({ titleize_slug }) => {
  return (
    <div key="content" className="content">
      <div className="name">{titleize_slug}</div>
    </div>
  );
};

const CampaignSearch = observer(function CampaignSearch({ store }) {
  const campaignSearch = store.campaignSearch;
  const noResultsMessage = (
    <p>
      Don’t see your favorite non-profit? You may recommend one by emailing us
      at <a href="mailto:admin@pcsgrades.com.">admin@pcsgrades.com.</a>
    </p>
  );

  const handleResultSelect = (e, { result }) => {
    campaignSearch.searchTerm = result.slug;
    window.location = `/campaigns/${result.slug}`;
  };

  const handleSearchChange = (e, { value }) => {
    campaignSearch.isLoading = true;
    campaignSearch.searchTerm = value;

    if (campaignSearch.searchTerm.trim().length < 1)
      return campaignSearch.resetSearch();
    getCampaigns(value, store.category, campaignSearch.replaceResults);
  };

  return (
    <>
      <label htmlFor="campaignSearch" className="font-semibold">
        Search for your {store.category}
      </label>
      <Search
        id="campaignSearch"
        loading={campaignSearch.isLoading}
        results={campaignSearch.results}
        value={campaignSearch.searchTerm}
        resultRenderer={resultRenderer}
        onResultSelect={handleResultSelect}
        onSearchChange={debounce(handleSearchChange, 300, { leading: true })}
        fluid
        noResultsMessage={noResultsMessage}
        className="mt-2 campaign-search-input"
        input={{
          icon: 'search',
        }}
      />
    </>
  );
});

export default CampaignSearch;
